import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=ead8209e&scoped=true&"
import script from "./DetailView.vue?vue&type=script&lang=js&"
export * from "./DetailView.vue?vue&type=script&lang=js&"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=ead8209e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead8209e",
  null
  
)

export default component.exports